/**
 * Last-seed persistence, guarded — localStorage can be unavailable or
 * partitioned (Electron file:// origins, private windows). Losing the seed
 * is a shrug; throwing in a menu is not. Distinct from the Profile store:
 * the profile carries progression and gets the file-backed bridge, the seed
 * is a convenience.
 */
const KEY = 'descent.lastSeed';

export function loadLastSeed(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function saveLastSeed(seed: string): void {
  try {
    localStorage.setItem(KEY, seed);
  } catch { /* ephemeral */ }
}
